import { Component, EventEmitter, Input, Output, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthHttpService } from '../../services/auth-http.service';

export interface SessionInfo {
  device: string;
  platform: string;
  ip: string;
  userId: string;
}

@Component({
  selector: 'app-active-session-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './active-session-modal.html',
  styleUrls: ['./active-session-modal.scss']
})
export class ActiveSessionModalComponent {
  @Input() sessionInfo: SessionInfo = { device: '', platform: '', ip: '', userId: '' };
  @Input() isVisible = false;

  /** Emitido cuando el usuario confirma la invalidación y ésta es exitosa en el backend. */
  @Output() success = new EventEmitter<void>();

  /** Emitido cuando el usuario cancela o cierra el modal sin invalidar. */
  @Output() cancel = new EventEmitter<void>();

  /** Emitido cuando el backend responde con error al intentar invalidar. */
  @Output() invalidationError = new EventEmitter<string>();

  private authService = inject(AuthHttpService);

  /** Indica si la llamada al backend está en curso para deshabilitar el botón. */
  readonly invalidating = signal(false);

  /** Mensaje de error inline si la invalidación falla. */
  readonly errorMessage = signal<string | null>(null);

  onContinue(): void {
    this.errorMessage.set(null);
    this.invalidating.set(true);

    this.authService.invalidatePreviousSession(this.sessionInfo.userId)
      .subscribe({
        next: () => {
          this.invalidating.set(false);
          // Solo emite success — el padre decide qué hacer a continuación
          // (reintentar login). No se emite cancel para no interrumpir ese flujo.
          this.success.emit();
        },
        error: (error: unknown) => {
          this.invalidating.set(false);
          const msg = 'No se pudo cerrar la sesión anterior. Intenta de nuevo.';
          this.errorMessage.set(msg);
          this.invalidationError.emit(msg);
          console.error('[ActiveSessionModal] Error al invalidar sesión:', error);
        }
      });
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onClose(): void {
    this.cancel.emit();
  }
}
